<template>
	<div class="input-container text-left">
		<ilabel :label="label" :required="required" v-if="label"/>
		<input
			@click="trigger"
			@blur="trigger"
			:class="{uppercase}"
			v-if="type==='string'"
			:disabled="disabled"
			type="text"
			:maxlength="max"
			:pattern="regex"
			:value="value"
			@keyup="change"
			class="inputi"
			:style="{width:type==='password'?'80%':'100%'}"
			:placeholder="placeholder"
			v-mask="mask?mask:''"
		/>
		<input
			@click="trigger"
			@blur="trigger"
			v-if="type==='number'"
			:disabled="disabled"
			inputmode="numeric"
			style="text-align:right"
			:step="step"
			:min="min"
			:max="max"
			pattern="[0-9]*"
			type="number"
			:value="value"
			@keyup="change"
			@change="change"
			class="inputi"
			:style="{width:type==='password'?'80%':'100%'}"
			:placeholder="placeholder"
		/>
		<input
			@click="trigger"
			@blur="trigger"
			v-if="type==='password'"
			:disabled="disabled"
			:type="passwordShown?'text':'password'"
			:value="value"
			@keyup="change"
			class="inputi"
			:style="{width:'90%',borderTopRightRadius:0,borderBottomRightRadius:0}"
			:placeholder="placeholder"/>

		<div v-if="type==='password'"
			 @touchstart="passwordShown = !passwordShown"
			 @click="passwordShown = !passwordShown"
			 class="password-show"
		>
			<icon :name="passwordShown?'eye':'eye-slash'" :size="20"/>
		</div>
		<div v-if="hint" class="hint">{{hint}}</div>
	</div>
</template>
<script>


	export default {
		name:"inputi",
		data(){
			return {passwordShown:false}
		},
		mounted(){
			//console.log(this.label, this.value);
		},
		props:{
			mask:[String, Object],
			min:{
				type:Number,
				default:0
			},
			max:{
				type:Number,
				default:9999999
			},
			step:{
				type:Number,
				default:1
			},
			placeholder:String,
			hint:String,
			m:String,
			regex: String,
			value:{type:[String, Number, Boolean], default:''},
			disabled:{
				type:Boolean,
				default:false
			},
			uppercase:{
				type:Boolean,
				default:false
			},
			label:String,
			size:{type:String, default:'m'},
			type:{
				type:String,
				default: "string"
			},
			required:{
			    type:Boolean,
				default:false
			}
		},
		methods:{
			change(e){
				let {value} = e.target;
				if(this.type==='number') value = parseFloat(value);
				this.$emit('input', value);
				this.$emit('change', value);
			},
			trigger(e){
				this.$emit(e.type, e);
			}
		}
	}
</script>
<style scoped>
	.input-container{
		margin-bottom:8px;
		overflow:hidden;
	}
	.inputi[disabled]{
		background: whitesmoke;
	}
	.inputi{
		-webkit-appearance: none;
		font-size:14px;
		padding:4px 8px;
		display: block;
		border:1px solid lightgrey;
		border-radius: 4px;
		background: white;
		width: 100%;
		box-sizing: border-box;
		outline:none;
		box-shadow: none;
		float:left;width:100%;
		vertical-align: top;
		margin:0;
		line-height: 1;
	}
	.inputi:focus{
		border-color: #27b9ec;
	}
	.hint{
		font-size: 12px;
		color:grey;
		margin:2px;
		text-align: right;
	}

	.password-show{
		display: block;
		float:left;
		width:10%;
		text-align: center;
		border:1px solid lightgrey;
		padding:2px;
		margin-left: -1px;
		line-height: 1;
		background: white;
		box-sizing: border-box;
	}
	.password-show:active{
		background: whitesmoke;
	}


	.span{
		color:#ff6f60;
	}

	label{font-size:14px;}

	uppercase{}
</style>